import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const TemplateTour = ({ autoStart = true, onComplete  }) => {
  const { startTour } = useShepherdTour('templates', TOUR_DATA.templates.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Template Tour
    </button> */}
    </>
  );
};

export default TemplateTour;
